@if (((rotated$ | async) && !showIfNoRotation()) || showIfNoRotation()) {
  <div
    class="igo-rotation-button-container"
    [matTooltip]="
      (rotated$ | async)
        ? ('igo.geo.mapButtons.resetRotation'
          | translate: { azimuth: azimuthRounded, rotation: rotationRounded })
        : ('igo.geo.mapButtons.tipRotation' | translate)
    "
    matTooltipPosition="left"
  >
    <button
      mat-icon-button
      matTooltipPosition="left"
      [color]="color()"
      [disabled]="(rotated$ | async) === false"
      (click)="map().viewController.resetRotation()"
    >
      <mat-icon [ngStyle]="currentStyle$ | async">navigation </mat-icon>
    </button>
  </div>
}
